import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  planCardContainer: {
    width: 312,
    marginRight: 32,
    display: "flex",
    flexDirection: "column",
    boxShadow: theme.palette.main.shadow.primary,
    borderRadius: 4,
    backgroundColor: theme.palette.natural.t4,
    paddingLeft: 10,
    paddingRight: 10,
  },
  favoriteText: {
    fontSize: 14,
    fontWeight: "400",
    color: theme.palette.natural.t2,
    textAlign: "center",
  },
  planTypeText: {
    textAlign: "center",
    fontSize: 28,
    textTransform: "uppercase",
    color: theme.palette.natural.t1,
    fontWeight: "bold",
    marginBottom: 8,
  },
  planTypeContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
  },
  starIconBox: {
    height: 42,
    width: 42,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  listContainer: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 24,
  },
  listItem: {
    display: "flex",
    flexDirection: "row",
    marginBottom: 16,
    alignItems: "center",
  },
  iconContainer: {
    height: 24,
    width: 24,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.main.accent.d2,
    marginRight: 16,
  },
  listItemText: {
    fontSize: 16,
    fontWeight: "400",
    color: theme.palette.natural.t1,
    lineHeight: 1.2,
    marginRight: 24,
  },
  planButtonContainer: {
    marginTop: 42,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 36,
    height: 44,
  },
  closeIconContainer: {
    height: 24,
    width: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 16,
  },
  numberOfShowsText: {
    marginTop: 32,
    textAlign: "center",
    fontSize: 16,
    fontWeight: "400",
    color: theme.palette.natural.t1,
  },
  numberOfNotificationText: {
    marginTop: 8,
    textAlign: "center",
    fontSize: 16,
    fontWeight: "700",
    color: theme.palette.natural.t,
  },
}));
